import React from "react";
import { BatchList } from "../../components/BatchList";
import Layout from "../../components/shared/Layout/Layout";

const BatchListPage = () => {
  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <Layout title="Batch  ">
        <BatchList />
      </Layout>
    </div>
  );
};

export default BatchListPage;
